import { IOfficialDailyDetailResponse } from "../../../model/base/response/official-daily-detail-response";

export interface IOfficialDailyDetailState {
    officialDailyDetail: IOfficialDailyDetailResponse | null;
    loading: boolean;
    error: string | null;
}

export const initialState: IOfficialDailyDetailState = {
    officialDailyDetail: null,
    loading: false,
    error: null
};

export enum ACTION_TYPES {
    SET_LOADING = 'SET_LOADING',
    SET_OFFICIAL_DAILY_DETAIL = 'SET_OFFICIAL_DAILY_DETAIL',
    SET_ERROR = 'SET_ERROR'
}

export const OfficialDailyDetailReducer = (state: IOfficialDailyDetailState, action: any): IOfficialDailyDetailState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.SET_LOADING:
            return {
                ...state,
                loading: payload
            };
        case ACTION_TYPES.SET_OFFICIAL_DAILY_DETAIL:
            return {
                ...state,
                officialDailyDetail: payload,
                loading: false,
                error: null
            };
        case ACTION_TYPES.SET_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
